import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationValuationBlockAgricultureActivityConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationValuationBlockAgricultureActivities";
    static FUNCTION_DELETE_MULTIPLE_VALUATION_BLOCK_AGRICULTURE_ACTIVITIES = "DeleteMultipleValuationBlockAgricultureActivities";
    static FUNCTION_UPLOAD_VALUATION_BLOCK_AGRICULTURAL_ATTRIBUTES = "UploadValuationBlockAgricultureActivities";
}
